import { Box, Center,Spinner, Text } from '@chakra-ui/react'
import React from 'react'

const FormLoader = () => {
    return (
        <Center h="400px">
            <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
                <Spinner size="lg" color="blue.500" thickness="3px" />
                <Text color="gray.500" fontSize="md" fontWeight="500">
                    Loading data...
                </Text>
            </Box>
        </Center>
    )
}

export default FormLoader